// Tier 1 (origin / heritage) jobs. Role-neutral starting professions.
// See docs/03-jobs-skills §3.4, ADR 0005 §2.2, ADR 0006 §2.1.
//
// Tier 1 jobs hold no Type tags (Type is established at Tier 2). Each Tier 1
// hub branches into 1-2 Tier 2 jobs (default + optional special axis).
//
// All growth bands follow the HHMLL pattern (sum_value = 5.0) per ADR 0006:
//   2 stats 'high' (1.5), 1 stat 'mid' (1.0), 2 stats 'low' (0.5).
// Per-job placement reflects the T2 branch directions; see ADR 0006 §2.1.
// Stat magnitudes diverge across Tiers via STAT_CURVE_BY_TIER; T1 saturates
// quickly around Lv 500 (asymptote 400 stat per growth_value unit).
export const JOB_WARRIOR = {
    id: 'warrior',
    name: '戦士',
    tier: 1,
    types: [],
    growth: { str: 'high', dex: 'mid', int: 'low', vit: 'high', wis: 'low' },
    ultimateSkillId: 'ult.warrior.greatcleave',
};
export const JOB_FORTUNE_TELLER = {
    id: 'fortune-teller',
    name: '占い師',
    tier: 1,
    types: [],
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.fortune-teller.starcast',
};
export const JOB_PRIEST_NOVICE = {
    id: 'priest-novice',
    name: '僧侶',
    tier: 1,
    types: [],
    growth: { str: 'low', dex: 'low', int: 'mid', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.priest-novice.prayer',
};
export const JOB_THIEF = {
    id: 'thief',
    name: '盗賊',
    tier: 1,
    types: [],
    growth: { str: 'high', dex: 'high', int: 'mid', vit: 'low', wis: 'low' },
    ultimateSkillId: 'ult.thief.backstab',
};
export const JOB_ENTERTAINER = {
    id: 'entertainer',
    name: '旅芸人',
    tier: 1,
    types: [],
    growth: { str: 'low', dex: 'high', int: 'mid', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.entertainer.encore',
};
export const JOB_HUNTER = {
    id: 'hunter',
    name: '狩人',
    tier: 1,
    types: [],
    growth: { str: 'high', dex: 'high', int: 'low', vit: 'mid', wis: 'low' },
    ultimateSkillId: 'ult.hunter.snare',
};
export const JOBS_TIER1 = [
    JOB_WARRIOR,
    JOB_FORTUNE_TELLER,
    JOB_PRIEST_NOVICE,
    JOB_THIEF,
    JOB_ENTERTAINER,
    JOB_HUNTER,
];
//# sourceMappingURL=tier1.js.map